export default {
  buttons: {
    login: 'Inloggen',
  },
  feedback: {
    incorrect_code: 'De ingevoerde code is onjuist. Probeer het opnieuw.',
    expired_code: 'Deze code is verlopen. Vraag een nieuwe aan.',
    too_many_attempts: 'Te veel pogingen. Wacht even en probeer het opnieuw.',
    unknown: 'Er is iets misgegaan bij het verifiëren van je code. Probeer het opnieuw.',
    network_error: 'We konden de server niet bereiken. Controleer je verbinding en probeer het opnieuw.',
  },
};
